import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { requestRefund, resetRequestRefund } from "./request-refund";

const initialState: ProcessingState = { processing: "idle" };

export const requestRefundReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(requestRefund.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(requestRefund.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(requestRefund.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetRequestRefund, () => {
    return initialState;
  });
});
